import { useTranslation } from 'react-i18next';

import TextField from 'components/shared/ControlledFields/ControlledTextField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

const FormFields = ({ control }) => {
  const { t } = useTranslation('common');

  return (
    <MultiStepForm.Section
      title={t('adminPortal.travelMovementsExport.formTitle')}
    >
      <TextField name="code" control={control} label={t('code')} disabled />
      <TextField name="name" control={control} label={t('name')} disabled />
      <TextField
        name="exportCode1"
        control={control}
        label={t('adminPortal.travelMovementsExport.exportCode1')}
      />
      <TextField
        name="exportCode2"
        control={control}
        label={t('adminPortal.travelMovementsExport.exportCode2')}
      />
    </MultiStepForm.Section>
  );
};

export default FormFields;
